<template>
  <div id="conference-loading" v-if="isLoading">
    <!-- Placeholder image or loading indicator -->
    <img
      class="d-none d-md-block mb-4"
      style="opacity: 0.6"
      src="/wp-content/themes/understrap-child/fidelio-templates/images/fourCardsPlaceholder.svg"
      alt=""
    />
    <img
      class="d-md-none mb-4"
      style="opacity: 0.6"
      src="/wp-content/themes/understrap-child/fidelio-templates/images/categoryPlacholderMobile.svg"
      alt=""
    />
  </div>
  <div
    v-if="conferences && conferences.length"
    class="bg-white mb-4 px-5 py-1 rounded-corners-10 conference"
  >
    <div class="text-primary my-3">
      <h5
        class="font-weight-bolder"
        style="font-size: x-large"
      >
        {{ $t('CategoryPage.conferencesAndAcademy') }}
      </h5>
    </div>

    <div class="splide conferenceSplide newFeatureSlider" aria-label="Slider for conferences">
      <div class="sands-article-vueslidercontainer splide__track">
        <div class="splide__list">
          <div
            class="sands-article-detail my-4 mb-3 splide__slide"
            v-for="(conference, i) in conferences"
            :key="i"
          >
            <div class="">
              <a :href="constructCourseURL(conference)" class="cursorPointer">
                <div class="d-flex flex-column">
                  <div
                    class="col-auto col-lg-auto d-flex p-0 rounded-top text-center"
                    :style="`background-color: ${conference.colourHexCode};`"
                  >
                    <div class="mx-auto">
                      <img
                        class="rounded card-img py-4"
                        style="
                          height: 140px;
                          max-height: 140px;
                          object-fit: contain;
                        "
                        loading="lazy"
                        :src="conference.transparentLogo.svg"
                        alt=""
                      />
                    </div>
                  </div>
                  <div class="col-12 py-3 p-0 h-100 d-flex flex-column">
                    <h5
                      v-if="conference.name"
                      style="font-size: larger"
                      class="text-break text-dark"
                    >
                      {{ conference.name }}
                    </h5>
                    <div class="my-3 h6 text-dark h-100">
                      <p
                        v-if="
                          conference.localizedStartDate &&
                          conference.localizedEndDate
                        "
                      >
                        {{
                          formatStartDate(
                            conference.localizedStartDate,
                            conference.localizedEndDate
                          )
                        }}
                      </p>
                    </div>
                    <span v-if="conference.experts">
                      <span class="d-flex align-items-end flex-wrap">
                        <span>
                          <cite title="Source Title">{{
                            conference.experts
                          }}</cite>
                        </span>
                      </span>
                    </span>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Splide from "@splidejs/splide";
import CONCORD_QUERIES from "../../services/concord_queries.js";
import helperFunction from "../../services/helperfunctions.js";
import { watch } from "vue";
import moment from "moment";
import useElementVisible from "../../services/elementVisibilityService.js";
import axios_queries from "../../services/axios_queries.js";

export default {
  name: "categoryConference",
  props: {
    settingsPerm: Object,
  },
  data() {
    return {
      isLoading: false,
      conferences: false,
      loadMorePossible: true,
      isDevMioActive: false,
      currentPage: 1,
      metaCount: 0,
      splide: null,
      firstTimeInViewport: true,
      initialDataLoaded: false,
    };
  },
  created() {
    this.isLoading = true;
    setTimeout(() => {
      this.box1Ref = document.getElementById("conference-loading");
      if (this.box1Ref) {
        const isVisible = useElementVisible(this.box1Ref);
        if (isVisible && isVisible.value && isVisible.value == true) {
          this.firstTimeInViewport = false;
          this.loadInitialData();
        }

        watch(isVisible, (newValue) => {
          if (this.firstTimeInViewport && isVisible && newValue === true) {
            this.firstTimeInViewport = false;
            this.loadInitialData();
          }
          // Do something when isVisible changes
        });
      }
    }, 500);
    if (this.settingsPerm && this.settingsPerm.isDevMioActive) {
      this.isDevMioActive = this.settingsPerm.isDevMioActive;
    }
  },

  methods: {
    loadInitialData() {
      if (!this.initialDataLoaded) {
        this.initialDataLoaded = true;
        let conferenceLoadingParams = {
          page: 1,
          pagesize: 12,
          querystring: this.settingsPerm.cat,
          transientKey: this.settingsPerm.cat + "-cat-depending-conference-vue",
          query: "cat-depending-conference-vue",
          url:
            this.settingsPerm.ajaxUrl +
            "/wp-content/uploads/catpages/" +
            this.settingsPerm.cat +
            "-cat-depending-conference-vue.json",
        };
        axios_queries
          .loadPublicData(conferenceLoadingParams)
          .then((concordData) => {
            if (
              concordData &&
              concordData != null &&
              concordData != undefined &&
              concordData != ""
            ) {
              if (
                concordData.advancedSearch &&
                concordData.advancedSearch.courses &&
                concordData.advancedSearch.courses.Courses &&
                concordData.advancedSearch.courses.Courses.length
              ) {
                this.displayConferences(
                  concordData.advancedSearch.courses.Courses
                );
              } else {
                this.isLoading = false;
              }
            } else {
              this.isLoading = false;
            }
        });
      }
    },

    displayConferences(conferences) {
      this.conferences = conferences;
      this.isLoading = false;
      this.mount_splide();
    },

    async loadMoreData() {
      // Make an API call to fetch more data
      const nextPage = this.currentPage + 1;
      let variablesForQuery = {
        page: nextPage,
        pagesize: 12,
        querystring: this.settingsPerm.cat,
      };
      let graphqlQuery = CONCORD_QUERIES.CAT_SPECIFIC_CONFERENCES;
      let concordData = await axios_queries.getMoreData(
        graphqlQuery,
        variablesForQuery
      );
      if (
        concordData &&
        concordData.advancedSearch &&
        concordData.advancedSearch.courses &&
        concordData.advancedSearch.courses.Courses &&
        concordData.advancedSearch.courses.Courses.length
      ) {
        const newconferences = concordData.advancedSearch.courses.Courses;
        // console.log('New Courses',newCourses);
        this.conferences = [...this.conferences, ...newconferences];
        // console.log('conferences',this.conferences);
        this.isLoading = false;
        this.currentPage = nextPage;
        this.mount_splide();
      }
    },

    addMovedEventListener() {
      this.splide.on("moved", (newIndex) => {
        const lastCardIndex = newIndex + this.splide.options.perPage;
        // console.log('lastcardindex', lastCardIndex);
        // console.log('lenght', this.conferences.length);

        if (
          lastCardIndex === this.conferences.length - 2 &&
          this.conferences.length > this.metaCount
        ) {
          this.loadMoreData();
        }
      });
    },
    constructCourseURL(concordObject) {
      return helperFunction.sandsConstructRealUrl(concordObject);
    },

    formatStartDate(startDate, endDate) {
      const startMoment = moment(startDate, "DD-MM-YYYY HH:mm:ss");
      const endMoment = moment(endDate, "DD-MM-YYYY HH:mm:ss");
      if (startMoment.isValid() && endMoment.isValid()) {
        const formattedStartDate = startMoment.format("DD. MMM. ");
        const formattedEndDate = endMoment.format("DD. MMM. YYYY");

        if (formattedStartDate === formattedEndDate) {
          return `${formattedStartDate}`;
        } else {
          return `${formattedStartDate} - ${formattedEndDate}`;
        }
      } else {
        return "Invalid Date";
      }
    },

    mount_splide: function () {
      let thiz = this;
      setTimeout(function () {
        if (!thiz.splide) {
          thiz.splide = new Splide(".conferenceSplide", {
            classes: {
              prev: "splide__arrow--prev xx",
              next: "splide__arrow--next xxx",
              arrow: "splide__arrow xxxx",
            },
            perPage: 4,
            perMove: 1,
            // cover: true,
            // trimSpace: false,
            rewindByDrag: true,
            gap: "1rem",
            breakpoints: {
              1600: {
                perPage: 4,
                padding: {
                  right: "0rem",
                  left: "0rem",
                },
              },
              1200: {
                perPage: 3,
                padding: {
                  right: "0rem",
                  left: "0rem",
                },
              },
              991: {
                perPage: 2,
                padding: {
                  right: "0rem",
                  left: "0rem",
                },
              },
              767: {
                perPage: 1,
                padding: {
                  right: "0rem",
                  left: "0rem",
                },
              },
            },
            rewind: false,
            pagination: false,
          });
          thiz.splide.mount();
          thiz.addMovedEventListener(); // Add event listener
        } else {
          thiz.splide.refresh(); // Refresh the existing Splide instance
        }
      }, 100);
    },
  },
};
</script>

<style>
.title-container-conferences {
  height: 4em;
  text-overflow: ellipsis;
  /* margin-bottom: 3em; */
}

@media only screen and (max-width: 768px) {
  .title-mobile-conferences {
    height: 5em;
    text-overflow: ellipsis;
  }
}

/* Media query for tablet devices (medium-sized screens) */
@media only screen and (min-width: 768px) and (max-width: 1023px) {
  .title-tablet-conferences {
    height: 3em;
    text-overflow: ellipsis;
  }
}
</style>
